import { useDispatch, useSelector } from "react-redux";

import type { JsonModalAction } from "@src/services/state/layoutReducer";
import { hideJsonModal, showJsonModal } from "@src/services/state/layoutReducer";
import type * as T from "@src/types";

const useLayoutState = () => useSelector((state: T.ReduxState) => state.layout);

export const useJsonModal = () => {
  const dispatch = useDispatch();
  const { jsonModal } = useLayoutState();

  const showModal = (data: any, title?: string, actions?: JsonModalAction[]) => {
    dispatch(showJsonModal({ data, title, actions }));
  };

  const hideModal = () => {
    dispatch(hideJsonModal());
  };

  return {
    jsonModal,
    showJsonModal: showModal,
    hideJsonModal: hideModal,
  };
};
